import React from 'react'
import { createRoot } from 'react-dom/client'

import './utils/dayjsSetup'
import Application from './components/Application'
import './assets/styles/styles.scss'

const rootElement = document.getElementById('react-root')

const root = createRoot(rootElement)
root.render(<Application />)

if (module.hot) {
  module.hot.accept()
}
